module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_3016.168813f9.png";